import { configureStore } from '@reduxjs/toolkit'

import censusReducer from 'src/redux/census/censusSlice'
import dashboardReducer from 'src/redux/dashboard/dashboardSlice'
import demographicsReducer from 'src/redux/demographics/demographicsSlice'
import encountersReducer from 'src/redux/encounters/encountersSlice'
import forgotPasswordSlice from 'src/redux/forgotPassword/forgotPasswordSlice'
import messageReducer from 'src/redux/messages/messageSlice'
import practiceIqReducer from 'src/redux/practiceIq/PracticeIqSlice'
import progressNoteSlice from 'src/redux/progressNote/progressNoteSlice'
import providerHoldReducer from 'src/redux/providerHold/providerHoldSlice'
import sidePanelReducer from 'src/redux/sidePanel/sidePanelSlice'
import userReducer from 'src/redux/user/userSlice'

export const allReducers = {
  census: censusReducer,
  dashboard: dashboardReducer,
  demographics: demographicsReducer,
  encounters: encountersReducer,
  forgotPassword: forgotPasswordSlice,
  messages: messageReducer,
  practiceIq: practiceIqReducer,
  progressNote: progressNoteSlice,
  providerHold: providerHoldReducer,
  sidePanel: sidePanelReducer,
  user: userReducer,
}

const store = configureStore({
  reducer: allReducers,
})

export default store
